// eslint-disable-next-line deprecate/import
import Default from 'react-tooltip';
export default Default;
